var Tabs = {

  $btn: undefined,
  param: undefined,

  init: function () {
    this.tab();
    this.getPram();
    this.defineParam();
    this.scrollTop();
  },

  getPram: function() {
    this.param = location.search;
  },

  defineParam: function() {
    if(!this.param){
      this.$btn.first().trigger('click');
    } else {
      this.param = this.param.split('?')[1].split('=')[1];
      if(this.param === '1'){
        this.$btn.first().trigger('click');
      }
    }
  },

// タブの挙動
// 同一のページに複数個あっても機能する
  tab: function() {
    this.$btn = $('.js-tab').children('.tab-btn').children('li');
    var $closest;
    var _index = 0;

    this.$btn.on('click',function(){
      $closest =  $(this).closest('.js-tab');

      _index = $(this).index();
      this.$btn = $closest.children('.tab-btn').children('li');
      $cnts = $closest.children('.tab-contents').children('li');

      this.$btn.removeClass('is-active');
      $cnts.removeClass('is-active');

      this.$btn.eq(_index).addClass('is-active');
      $cnts.eq(_index).addClass('is-active');
    });
  },

  scrollTop: function () {
    var $btn = $('.js-pagetop-btn');

    $btn.on('click',function(){
      $('body,html').animate({scrollTop:0}, 500, 'swing');
      return false;
    });
  }
};

module.exports = Tabs;


//////////////////
// WEBPACK FOOTER
// ./htdocs_dev/_script/components/pagemodules/_tabs.js
// module id = 4
// module chunks = 0